module.exports = __webpack_public_path__ + "img/angle-left-solid-g.6b4482f5.svg";